import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowOutTopLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowOutTopLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3L11 3V5L6.41421 5L11.6642 10.25L10.25 11.6642L5 6.41421L5 11H3L3 3ZM13 6H22V22H6V13H8V20H20V8H13V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowOutTopLeft;
